export default __webpack_public_path__ + "static/media/sideSubjects.e8776a11.mp4";